export default "__VITE_ASSET__OE3gHzE2__"